// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025 Collab Digital Twins

import React from 'react'

export interface CdtIconProps {
  className?: string
  size?: number | string
  monochromatic?: boolean
}

// CDT logo icon - updated with new design
// White elements use currentColor to adapt to theme (light/dark mode)
// Orange accent remains fixed at #ef9262
export const CdtIcon = ({ className = 'h-4 w-4', size, monochromatic = false }: CdtIconProps) => {
  return (
    <svg
      id='cdt-logo'
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 466.83 448.49"
      fill="none"
      className={className}
      width={size}
      height={size}
    >
      <g id="cdt_logo">
        <path fill="currentColor" d="M450.47,199.92c6.06,6.07,9.09,14.01,9.09,21.95s-3.03,15.9-9.09,21.96l-195.57,195.56c-12.12,12.13-31.78,12.13-43.9,0l.07-.22c-.99-.76-1.95-1.61-2.86-2.52L9.1,237.53c-12.13-12.12-12.13-31.78,0-43.9l107.84-107.43c12.12-12.12,31.78-12.12,43.9,0,6.06,6.06,9.09,14.01,9.09,21.95s-3.03,15.89-9.09,21.95l-85.68,85.69,157.8,157.8.02-.07,152.28-152.28-121.22-121.22.21,119.39c0,10.42-3.46,19.86-9.06,26.69s-13.33,11.06-21.87,11.06c-17.08,0-30.92-16.9-30.92-37.75l-.31-188.49C202.09,13.84,218.82,0,239.45,0h181.34c10.32,0,20.82,3.98,27.58,9.57,6.76,5.6,10.94,13.33,10.94,21.87,0,17.08-16.72,30.93-37.36,30.93l-109.35-.32,136.34,136.34c.26.26.51.51.74.78h0c.27.24.53.49.79.75Z" />
        <path fill={monochromatic ? "currentColor" : "#ef9262"} d="M26.39,62.68l133.28.52c14.47,0,26.2-13.85,26.2-30.93h0c0-17.08-11.73-30.93-26.2-30.93L26.39.83c-14.47,0-26.2,13.85-26.2,30.93H.19c0,17.08,11.73,30.93,26.2,30.93Z" />
      </g>
    </svg>
  )
}
